module.exports = __webpack_public_path__ + "static/media/video-icon.77b77a43.svg";